import { Col, Row } from "antd"
import { IProject } from "../types/project.type"
import ProjectTable from "./ProjectTable"

const ProjectsTable: React.FC<{ projects: IProject[] }> = ({ projects }) => {
  return (
    <Row gutter={[16, 16]}>
      {projects.map((project) => (
        <Col span={6} key={project._id}>
          <ProjectTable project={project} />
        </Col>
      ))}
    </Row>
  )
}

export default ProjectsTable
